import React, { Component } from 'react';
import { connect } from 'react-redux'
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap'
import withAuth from '../../../../components/Services/WithAuth'
import classnames from 'classnames';
import TemplateDropdown from '../TemplateDropdown';
import { PREDEFINED, DATA } from '../../constants';
import { getSectionList } from '../Sections/Helper';
import { addPredefinedSections, getPredefinedSections, getDataSections, addDataSections } from '../action'
import { Preloading } from '../../../../components/UI/Preloader/action';
class AddSectionTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: PREDEFINED,
            predefList: [],
            dataList: [],
            warning: ""
        };
    }
    componentDidMount() {
        this.props.getPredefinedSections()
        this.props.getDataSections(this.props.computedReportId)
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                warning: ""
            });
        }
    }

    handleSelected = (param) => {
        this.setState({
            predefList: this.state.activeTab === PREDEFINED ? getSectionList(param) : [],
            dataList: this.state.activeTab === DATA ? getSectionList(param) : [],
            warning: ""
        })
    }

    onCancel = () => {
        this.props.toggleCorporateModal()
    }

    handleAddDataSections = () => {
        if (this.state.dataList.length > 0) {
            this.props.preloading(true);
            this.props.addDataSections(this.props.computedReportId, this.state.dataList)
            this.props.toggleCorporateModal()
        }
        else {
            this.setState({
                warning: "Select atleast one Data Section to add"
            })
        }
    }

    handleAddPredefSections = () => {
        if (this.state.predefList.length > 0) {
            this.props.preloading(true);
            this.props.addPredefinedSections(this.props.computedReportId, this.state.predefList)
            this.props.toggleCorporateModal()
        }
        else {
            this.setState({
                warning: "Select atleast one Predefined Section to add"
            })
        }
    }

    render() {
        return (
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === PREDEFINED })}
                            onClick={() => { this.toggle(PREDEFINED); }}
                            href="javascript:void(0)"
                        >
                            Predefined Sections
            </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === DATA })}
                            onClick={() => { this.toggle(DATA); }}
                            href="javascript:void(0)"
                        >
                            Data Sections
            </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={PREDEFINED}>
                        <Row>
                            <Col sm="24">
                                <TemplateDropdown
                                    predefinedSection={this.props.predefinedSection.data}
                                    selected={this.handleSelected}
                                    isMulti="true" />
                                <strong className="text-danger mb-2">{this.state.warning}</strong>
                                <br />
                                <button className="btn btn-primary mt-3" onClick={this.handleAddPredefSections}>Add</button>
                                <button className="btn btn-danger mt-3 ml-3" onClick={this.onCancel} >Cancel</button>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId={DATA}>
                        <Row>
                            <Col sm="24">
                                <TemplateDropdown
                                    dataSection={this.props.dataSections.data}
                                    selected={this.handleSelected}
                                    isMulti="true" />
                                <strong className="text-danger mb-2">{this.state.warning}</strong>
                                <br />
                                <button className="btn btn-primary mt-3" onClick={this.handleAddDataSections}>Add</button>
                                <button className="btn btn-danger mt-3 ml-3" onClick={this.onCancel} >Cancel</button>
                            </Col>
                        </Row>
                    </TabPane>

                </TabContent>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    predefinedSection: state.section.predefinedSection,
    dataSections: state.section.dataSections
})

const mapDispatchToProps = (dispatch) => ({
    addPredefinedSections: (id, List) => { dispatch(addPredefinedSections(id, List)) },
    getPredefinedSections: () => { dispatch(getPredefinedSections()) },
    getDataSections: (id) => { dispatch(getDataSections(id)) },
    addDataSections: (id, List) => { dispatch(addDataSections(id, List)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(AddSectionTab))
